import { React, useContext, useEffect, useState } from 'react';
import {
  chakra,
  Button,
  Heading,
  VStack,
  Text,
  Center,
  Stack,
  HStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Image,
  useMediaQuery,
  useToast,
} from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import Warning from '../../images/cartaoAtualizacao.svg';
import { useNavigate } from 'react-router-dom';

const ModalDescontarAdesao = ({ disclosure, aceitaDescontar }) => {
  const { isOpen, onClose } = disclosure;
  const handleConfirm = (value) => {
    aceitaDescontar(value);
    onClose();
  };
  const { user, setUser } = useContext(AccountContext);
  const [miniLargeHeight] = useMediaQuery('(max-height: 592px)');
  const navigate = useNavigate();

  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered size={miniLargeHeight ? 'sm' : 'xs'}>
        <ModalOverlay />
        <ModalContent borderRadius="0.8em">
          <ModalBody>
            <VStack align="left" mt={'1em'}>
              <Image src={Warning} h={'3em'} />
              <chakra.span fontSize="18px" fontWeight={'bold'} textAlign={'center'}>
                Não fique sem acessar os benefícios de sua assinatura!
              </chakra.span>
              <Text fontSize="16px" color="#585858" textAlign={'center'}>
                Confirme sua assinatura realizando o pagamento da adesão ao cadastrar seu cartão. Depois disso, é só aproveitar!
              </Text>
            </VStack>
            <HStack spacing={3} align="start" mt={'2em'} mb={'2em'}>
              <Button
                isFullWidth
                borderRadius={'0.8em'}
                color={'#CCCCCC'}
                fontWeight="bold"
                border={'1px solid #CCCCCC'}
                bg={'white'}
                fontSize={'14px'}
                _focus={false}
                onClick={() => handleConfirm(false)}
              >
                Pagar depois
              </Button>
              <Button
                bg={'orange'}
                borderColor=""
                borderRadius={'0.8em'}
                color={'white'}
                isFullWidth
                fontWeight="bold"
                fontSize={'14px'}
                onClick={() => handleConfirm(true)}
              >
                Pagar agora
              </Button>
            </HStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalDescontarAdesao;
